import ImageWithPreview from './ImageWithPreview';

export default ImageWithPreview;
